

export const routes = [
  // {
  //   title: "ABOUT US",
  //   // href: "/about",
  //   href: "#about",
  //   Icon: "SiBookstack",
  //   hash: false,
  // },
  {
    title: "Treatments",
    // href: "/treatments",
    // href: "/",
    Icon: "BsBuildingsFill",
    hash: false,
  },
  {
    title: "Our Doctors",
    href: "/1",
    Icon: "SiSoundcharts",
    hash: false,
  },
  {
    title: "Insurance",
    href: "/insurance",
    Icon: "SiSoundcharts",
    hash: false,
  },
  {
    title: "Contact Us",
    // href: "/contact",
    href: "#contact",
    Icon: "SiSoundcharts",
    hash: false,
  },
];

export const social = [
  {
    title: "LinkedIn",
    href: "https://www.linkedin.com/",
    Icon: "BiLogoLinkedin",
  },
  {
    title: "Twitter",
    href: "https://twitter.com/",
    Icon: "BiLogoTwitter",
  },
  {
    title: "YouTube",
    href: "https://www.youtube.com/",
    Icon: "TfiYoutube",
  },
  {
    title: "FaceBook",
    href: "http://facebook.com/",
    Icon: "BiLogoFacebook",
  },
  {
    title: "Instagram",
    href: "http://instagram.com/",
    Icon: "BiLogoInstagram",
  },
];





